import { Footer, FooterElement, FooterElementType } from '@easeltv/client-sdk';

import FooterLinksBlock from '../../Blocks/FooterLinksBlock';
import FooterTextBlock from '../../Blocks/FooterTextBlock';
import { StyledFooterSection } from './FooterSection.styled';

/* ---------------------------------- Types --------------------------------- */

export interface DumbFooterSectionI {
    /** Object representing the footer data */
    data: Footer;
}

/* -------------------------------- Component ------------------------------- */

/**
 * DumbFooterSection
 *
 * @param data DumbFooterSectionI
 * @returns JSX.Element
 */
const DumbFooterSection = ({ data }: DumbFooterSectionI) => (
    <StyledFooterSection>
        {data.elements.map((element: FooterElement) => {
            switch (element.type) {
                case FooterElementType.Text: {
                    return (
                        <FooterTextBlock
                            key={element.id}
                            text={element.text}
                            alignment={element.alignment}
                            horizontalPadding={element.horizontalPadding}
                            topPadding={element.topPadding}
                        />
                    );
                }
                case FooterElementType.Links: {
                    return (
                        <FooterLinksBlock
                            key={element.id}
                            links={element.links}
                            alignment={element.alignment}
                            horizontalPadding={element.horizontalPadding}
                            topPadding={element.topPadding}
                        />
                    );
                }
                default: {
                    return null;
                }
            }
        })}
    </StyledFooterSection>
);

/* --------------------------------- Export --------------------------------- */

export default DumbFooterSection;
